module.exports = __webpack_public_path__ + "static/media/image-apartment-topic2.f27926a2.jpg";